<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card class="pa-5">
      <v-card-title>
        <v-icon class="mr-2">mdi-clock-outline</v-icon>
        {{ $t("dashboard.productSampling.sessionExpiredDialog.title") }}
      </v-card-title>
      <v-card-text class="pl-14">
        {{ $t("dashboard.productSampling.sessionExpiredDialog.content") }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <wx-btn-standard color="secondary" @click="back">{{
          $t("dashboard.productSampling.sessionExpiredDialog.back")
        }}</wx-btn-standard>
        <wx-btn-standard color="primary" @click="restart">{{
          $t("dashboard.productSampling.sessionExpiredDialog.restart")
        }}</wx-btn-standard>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WxBtnStandard from "@/components/ui/WxBtnStandard.vue";

export default {
  components: { WxBtnStandard },
  name: "SessionExpiredDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
    restart() {
      this.$emit("restart");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  background-color: var(--color-base-background);
}
</style>
